<!-- sms-data-table.component.html -->
<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-sms-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      <!-- Dynamic column rendering -->
      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>

            <!-- Switch based on column.key -->
            @switch (column.key) {
              @case ('to') {
                <td mat-cell *matCellDef="let sms">
                  {{ sms.to }}
                </td>
              }
              @case ('tag') {
                <td mat-cell *matCellDef="let sms">
                  <aura-simple-chip [text]="sms.tag | smsTagDisplay" />
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let sms">
                  <aura-send-status-chip [status]="sms.status" />
                </td>
              }
              @case ('action') {
                <td mat-cell *matCellDef="let sms">
                  {{ sms.action | smsActionDisplay }}
                </td>
              }
              @case ('sendDate') {
                <td mat-cell *matCellDef="let sms">
                  {{ sms.sendDate | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let sms">
                  {{ sms.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('updatedAt') {
                <td mat-cell *matCellDef="let sms">
                  {{ sms.updatedAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('context') {
                <td mat-cell *matCellDef="let sms">
                  @if (sms.context?.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', sms.context.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(sms.context.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(sms.context.user.identity.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(sms.context.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(sms.context.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  } @else if (sms.context?.userRegistration) {
                    <div [matTooltip]="'Inscription'" class="inline-block text-gray-10">
                      {{
                        $safeNavigationMigration(sms.context.userRegistration.identity?.firstName) | titlecase
                      }}
                      {{
                        $safeNavigationMigration(sms.context.userRegistration.identity?.lastName) | titlecase
                      }}
                    </div>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let sms">
                  {{ sms[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
